import type { LeadTarget } from './resources';

/** Texto do alvo: "3 leads selecionados" / "os 120 leads do filtro atual". */
export const targetLabel = (target: LeadTarget, count: number | null) =>
  'ids' in target
    ? `${target.ids.length} lead(s) selecionado(s)`
    : count === null
      ? 'os leads do filtro atual'
      : `os ${count} lead(s) do filtro atual`;
